module.exports = "/virtual-football-league/img/video/clubs/france/psg.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/france/psg.png
// module id = 342
// module chunks = 4